/* eslint-disable no-return-assign */
import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';

function ViewLogsModal({ data, getLogs, logs }) {
  const setModal = useContext(ModalContext);

  useEffect(() => {
    getLogs(data.id);
  }, []);

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  return (
    <Modal.Body>
      <form>
        <div className="row">
          <div className="col-12">
            <div className="table-responsive">
              <table className="table table-striped table-sm table-bordered table-hover">
                <thead className="table-header">
                  <tr>
                    <th>CREATED BY</th>
                    <th>STATUS</th>
                    <th>DATE</th>
                    <th>REMARKS</th>
                  </tr>
                </thead>
                <tbody className="table-details">
                  {!_.isEmpty(logs) ? (logs.map(item => {
                    return (
                      <tr key={item.id}>
                        <td>{_.get(item, 'attributes.created_by') || '---'}</td>
                        <td>{_.get(item, 'attributes.status') || '---'}</td>
                        <td>{_.get(item, 'attributes.created_at') || '---'}</td>
                        <td>{_.get(item, 'attributes.remarks') || '---'}</td>
                      </tr>
                    );
                  })
                  ) : (
                    <tr className="text-center">
                      <td colSpan="7">No data</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button type="button" onClick={closeModal} className="btn btn-dark ">
            <span className="font-weight-bold">Close</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

ViewLogsModal.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  getLogs: PropTypes.instanceOf(Function).isRequired,
  logs: PropTypes.instanceOf(Array).isRequired
};

const mapStateToProps = ({ api }) => ({
  logs: _.get(api, `${c.GET_LOGS}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ViewLogsModal);
